export default __webpack_public_path__ + "static/media/Spin torre M_Interactive LightMix0015.69ef3d87.webp";